var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlogThumbnail1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 438,
    height: 197,
    viewBox: "0 0 438 197",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1046_17094)",
    filter: "url(#filter0_d_1046_17094)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 434,
    height: 189,
    transform: "translate(4 4)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.78 207.295C372.406 205.155 340.83 187.151 307.929 168.388C267.299 145.235 225.297 121.269 167.359 123.849C130.351 125.501 106.413 139.137 85.2778 151.188C66.1589 162.089 48.1072 171.609 24.4454 171.14C-13.8204 170.417 -26.1215 153.39 -26.2924 152.393L-25.6946 141.95C-25.6542 142.13 -18.3663 160.869 24.8541 163.116C46.1479 164.233 62.4384 154.942 81.2947 144.203C103.215 131.717 128.043 117.574 167.007 115.832C227.281 113.158 270.315 137.689 311.927 161.405C355.475 186.243 397.059 209.552 452.419 194.476L451.928 203.052C435.945 207.401 423.543 208.082 409.78 207.295Z",
    fill: "url(#paint0_radial_1046_17094)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.631 172.566C159.447 168.289 140.739 146.617 122.442 125.418C108.567 109.348 94.1461 92.8611 76.0287 83.0037C20.7855 52.9343 -15.1298 86.3208 -15.4584 86.6258L-13.6355 75.0385C-13.2493 74.6916 -6.83063 68.5922 9.66506 64.4349C24.6767 60.6301 49.031 59.5438 79.8122 75.9801C99.2977 86.3841 114.165 103.604 128.513 120.232C157.644 153.965 182.802 183.124 239.242 152.559C281.993 129.395 322.359 107.283 359.354 102.707C395.542 98.2336 430.496 111.173 458.993 150.234L457.327 160.826C396.862 77.5214 328.332 113.421 243.086 159.585C220.48 171.775 202.169 174.985 186.631 172.566Z",
    fill: "url(#paint1_linear_1046_17094)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.121 111.57H210.375V191.634H438.121V111.57Z",
    fill: "url(#paint2_linear_1046_17094)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.824 117.586V137.716H299.661V151.179H308.813V139.942H315.869V156.023H314.437V158.627H330.645V155.893H329.07V140.463H332.872V136.804H339.797V165.033L346.723 171.973L349.08 169.617H351.371V130.398H359.273V133.536L365.288 139.539H370.118V130.398H375.091V153.927H383.058V136.935H389.593V124.122H398.225V138.237H413.001V117.586H291.824Z",
    fill: "url(#paint3_linear_1046_17094)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.809 117.588H305.281V151.181H308.809V117.588Z",
    fill: "url(#paint4_linear_1046_17094)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.363 158.629V129.176H315.604V122.119H308.809V117.588H329.065V155.895H330.641V158.629H323.363Z",
    fill: "url(#paint5_linear_1046_17094)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.72 171.975V125.557H339.924V136.806H336.135V126.872H329.066V117.588H351.367V169.619H349.076L346.72 171.975Z",
    fill: "url(#paint6_linear_1046_17094)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.284 139.541V127.132L360.936 122.783H357.564V120.531H351.367V117.588H370.114V139.541H365.284Z",
    fill: "url(#paint7_linear_1046_17094)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.055 117.588H379.723V153.929H383.055V117.588Z",
    fill: "url(#paint8_linear_1046_17094)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.997 138.239H406.853V122.809H402.4V119.762H383.055V117.588H412.997V138.239Z",
    fill: "url(#paint9_linear_1046_17094)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.586 136.937H387.035V122.353L383.48 118.799H389.586V136.937Z",
    fill: "url(#paint10_linear_1046_17094)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.658 117.588H296V137.718H299.658V117.588Z",
    fill: "url(#paint11_linear_1046_17094)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.125 111.506V116.896C437.826 117.013 437.487 117.117 437.123 117.222C436.889 117.287 436.641 117.352 436.381 117.417C435.157 117.716 433.608 117.99 431.694 118.198C430.171 118.367 426.5 118.498 421.344 118.667C420.876 118.68 420.407 118.706 419.912 118.719C414.262 118.914 407.05 119.175 398.979 119.604C398.51 119.63 398.015 119.656 397.547 119.682C392.547 119.956 387.236 120.307 381.768 120.75C381.299 120.789 380.818 120.828 380.336 120.867C373.449 121.44 366.367 122.169 359.389 123.094C358.908 123.159 358.439 123.224 357.957 123.289C352.568 124.031 347.256 124.891 342.179 125.906C341.697 125.998 341.215 126.102 340.747 126.193C336.62 127.039 332.662 127.99 328.952 129.057C328.054 129.318 327.181 129.578 326.322 129.852C325.567 130.086 324.838 130.32 324.109 130.568C301.652 138.107 291.029 150.594 314.358 171.492C321.05 177.481 330.514 184.161 343.285 191.622H175.594V110.659H436.654C436.654 110.659 436.836 110.75 437.123 110.907C437.396 111.05 437.748 111.258 438.125 111.506Z",
    fill: "url(#paint12_linear_1046_17094)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.371 115.855V95.7121H183.208V82.2488H192.36V93.4986H199.416V77.4181H197.984V74.8009H214.192V77.5483H212.617V92.9778H216.405V96.6366H223.344V68.3948L230.27 61.4678L232.614 63.8115H234.918V103.043H242.82V99.9048L248.835 93.8893H253.664V103.043H258.638V79.5014H266.605V96.5064H273.14V109.319H281.771V95.1913H296.534V115.855H175.371Z",
    fill: "url(#paint13_linear_1046_17094)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.364 82.248H188.836V115.841H192.364V82.248Z",
    fill: "url(#paint14_linear_1046_17094)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.918 74.8008V104.254H199.159V111.324H192.363V115.855H212.62V77.5481H214.195V74.8008H206.918Z",
    fill: "url(#paint15_linear_1046_17094)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.274 61.4678V107.873H223.479V96.6366H219.677V106.571H212.621V115.855H234.922V63.8115H232.618L230.274 61.4678Z",
    fill: "url(#paint16_linear_1046_17094)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.839 93.8887V106.31L244.49 110.659H241.119V112.912H234.922V115.855H253.669V93.8887H248.839Z",
    fill: "url(#paint17_linear_1046_17094)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.61 79.502H263.277V115.843H266.61V79.502Z",
    fill: "url(#paint18_linear_1046_17094)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.539 95.1914H288.311V110.621H285.955V113.668H266.609V115.855H296.539V95.1914Z",
    fill: "url(#paint19_linear_1046_17094)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.141 96.5059H270.589V111.076L267.035 114.644H273.141V96.5059Z",
    fill: "url(#paint20_linear_1046_17094)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.213 95.7119H179.555V115.842H183.213V95.7119Z",
    fill: "url(#paint21_linear_1046_17094)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.824 115.855V95.7121H299.661V82.2488H308.813V93.4986H315.869V77.4181H314.437V74.8009H330.645V77.5483H329.07V92.9778H332.872V96.6366H339.797V68.3948L346.723 61.4678L349.08 63.8115H351.371V103.043H359.273V99.9048L365.288 93.8893H370.118V103.043H375.091V79.5014H383.058V96.5064H389.593V109.319H398.225V95.1913H413.001V115.855H291.824Z",
    fill: "url(#paint22_linear_1046_17094)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.809 82.248H305.281V115.841H308.809V82.248Z",
    fill: "url(#paint23_linear_1046_17094)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.363 74.8008V104.254H315.604V111.324H308.809V115.855H329.065V77.5481H330.641V74.8008H323.363Z",
    fill: "url(#paint24_linear_1046_17094)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.72 61.4678V107.873H339.924V96.6366H336.135V106.571H329.066V115.855H351.367V63.8115H349.076L346.72 61.4678Z",
    fill: "url(#paint25_linear_1046_17094)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.284 93.8887V106.31L360.936 110.659H357.564V112.912H351.367V115.855H370.114V93.8887H365.284Z",
    fill: "url(#paint26_linear_1046_17094)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.055 79.502H379.723V115.843H383.055V79.502Z",
    fill: "url(#paint27_linear_1046_17094)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.997 95.1914H406.853V110.621H402.4V113.668H383.055V115.855H412.997V95.1914Z",
    fill: "url(#paint28_linear_1046_17094)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.586 96.5059H387.035V111.076L383.48 114.644H389.586V96.5059Z",
    fill: "url(#paint29_linear_1046_17094)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.658 95.7119H296V115.842H299.658V95.7119Z",
    fill: "url(#paint30_linear_1046_17094)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.91 114.669C209.91 114.669 220.286 109.956 222.408 111.362C224.53 112.781 234.19 109.656 241.037 111.102C247.872 112.547 251.882 115.893 258.482 112.69C265.083 109.487 272.868 110.711 274.039 112.69C275.224 114.669 276.864 113.771 284.415 112.69C291.953 111.61 291.484 112.078 301.391 114.669C311.298 117.26 317.808 117.26 317.808 117.26H209.923V114.669H209.91Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.524 120.255C195.524 120.255 197.881 111.609 210.144 115.854C222.407 120.099 225.076 125.281 242.833 124.656C260.591 124.031 268.454 132.521 275.679 132.364C282.905 132.208 283.295 135.672 283.295 135.672H192.387L195.524 120.255Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.551 117.261C387.51 117.287 375.077 117.703 359.403 119.422C358.934 119.474 358.452 119.526 357.971 119.578C345.798 120.959 331.855 123.133 319.826 126.505C319.345 126.636 318.876 126.779 318.394 126.909C314.671 128.003 311.143 129.214 307.94 130.555C296.328 135.425 288.868 142.052 290.912 151.036C293.893 164.083 309.255 178.211 329.161 191.596H294.466C285.536 181.947 278.427 171.739 275.303 161.674C270.707 146.805 276.149 137.026 288.087 130.555C295.794 126.362 306.222 123.563 318.381 121.636C318.85 121.558 319.332 121.492 319.813 121.414C331.296 119.683 344.275 118.719 357.958 118.12C358.439 118.094 358.908 118.081 359.39 118.055C368.88 117.69 378.683 117.456 388.551 117.261Z",
    fill: "url(#paint31_linear_1046_17094)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.397 115.372C272.397 115.372 279.7 117.612 284.66 113.667C289.607 109.721 301.87 110.073 307.286 113.667C312.702 117.26 319.315 115.242 322.609 113.419C325.916 111.596 332.269 112.117 340.288 113.979C348.308 115.841 348.308 113.172 356.314 113.419C364.333 113.667 388.613 117.26 388.613 117.26H269.09L272.397 115.372Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.832 117.26C358.832 117.26 367.945 110.021 372.671 112.026C377.396 114.031 381.693 116.531 384.921 114.474C388.15 112.416 393.305 112.234 394.802 114.057C396.312 115.88 401.689 114.799 404.501 114.474C412.078 113.614 415.111 117.273 415.111 117.273H358.832V117.26Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.909 191.622H197.957V181.362C197.957 181.362 202.409 173.263 209.7 171.505C211.418 171.089 213.293 171.024 215.298 171.505C216.639 171.818 218.032 172.378 219.49 173.224C232.417 180.789 243.509 171.518 252.283 182.508C261.058 193.51 270.301 179.005 285.832 188.029C287.902 189.239 289.555 190.437 290.909 191.622Z",
    fill: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.82 29.1631C333.273 29.1631 333.64 28.7958 333.64 28.3428C333.64 27.8897 333.273 27.5225 332.82 27.5225C332.367 27.5225 332 27.8897 332 28.3428C332 28.7958 332.367 29.1631 332.82 29.1631Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.937 74.7998C370.937 75.2555 370.573 75.6201 370.117 75.6201C369.661 75.6201 369.297 75.2555 369.297 74.7998C369.297 74.3441 369.661 73.9795 370.117 73.9795C370.573 73.9795 370.937 74.3441 370.937 74.7998Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.84 8.36946C315.84 8.82518 315.475 9.18976 315.019 9.18976C314.564 9.18976 314.199 8.82518 314.199 8.36946C314.199 7.91374 314.564 7.54916 315.019 7.54916C315.462 7.53613 315.84 7.91374 315.84 8.36946Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.766 48.7594C321.766 49.6188 321.076 50.3089 320.217 50.3089C319.358 50.3089 318.668 49.6188 318.668 48.7594C318.668 47.9001 319.358 47.21 320.217 47.21C321.076 47.21 321.766 47.9001 321.766 48.7594Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.332 22.7044C309.175 23.3814 308.485 23.7981 307.821 23.6288C307.144 23.4726 306.728 22.7825 306.897 22.1184C307.053 21.4414 307.743 21.0247 308.407 21.194C309.071 21.3502 309.488 22.0273 309.332 22.7044Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.683 66.3107C308.605 66.6232 308.292 66.8185 307.967 66.7534C307.654 66.6752 307.459 66.3627 307.524 66.0372C307.602 65.7247 307.915 65.5294 308.24 65.5945C308.566 65.6727 308.761 65.9982 308.683 66.3107Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.309 51.8717C358.309 52.7311 357.619 53.4212 356.76 53.4212C355.901 53.4212 355.211 52.7311 355.211 51.8717C355.211 51.0124 355.901 50.3223 356.76 50.3223C357.606 50.3223 358.309 51.0124 358.309 51.8717Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.761 7.67883C347.683 7.99133 347.37 8.18664 347.045 8.12154C346.733 8.04341 346.537 7.73092 346.602 7.4054C346.68 7.0929 346.993 6.89759 347.318 6.9627C347.644 7.04082 347.839 7.36634 347.761 7.67883Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.116 66.3107C387.038 66.6232 386.726 66.8185 386.4 66.7534C386.088 66.6752 385.893 66.3627 385.958 66.0372C386.036 65.7247 386.348 65.5294 386.674 65.5945C386.986 65.6727 387.195 65.9982 387.116 66.3107Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.386 40.713C240.308 41.0255 239.995 41.2208 239.67 41.1557C239.358 41.0776 239.162 40.7651 239.227 40.4396C239.305 40.1271 239.618 39.9318 239.943 39.9969C240.269 40.075 240.464 40.4005 240.386 40.713Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.281 60.7775C416.202 61.09 415.89 61.2853 415.564 61.2202C415.252 61.142 415.057 60.8295 415.122 60.504C415.2 60.1915 415.512 59.9962 415.838 60.0613C416.163 60.1395 416.359 60.465 416.281 60.7775Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.219 45.5172C279.219 46.3766 278.53 47.0667 277.67 47.0667C276.811 47.0667 276.121 46.3766 276.121 45.5172C276.121 44.6579 276.811 43.9678 277.67 43.9678C278.53 43.9678 279.219 44.6579 279.219 45.5172Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.792 16.4933C279.714 16.8058 279.402 17.0011 279.076 16.936C278.764 16.8579 278.569 16.5454 278.634 16.2199C278.712 15.9074 279.024 15.712 279.35 15.7772C279.675 15.8553 279.87 16.1808 279.792 16.4933Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.699 -44H272.113V24.3585H272.699V-44Z",
    fill: "#EBF3F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.945 30.634C250.945 30.634 261.438 21.9102 272.4 21.9102C283.361 21.9102 293.854 30.634 293.854 30.634H250.945Z",
    fill: "#EBF3F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.551 -44H200.965V24.3585H201.551V-44Z",
    fill: "#EBF3F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.797 30.634C179.797 30.634 190.29 21.9102 201.251 21.9102C212.226 21.9102 222.706 30.634 222.706 30.634H179.797Z",
    fill: "#EBF3F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.125 165.724H70V192.976H438.125V165.724Z",
    fill: "#EEF6FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.464 50.9336C212.725 49.2409 212.738 47.5352 212.53 45.8686L215.524 43.9155L214.092 40.3088L212.66 36.702L209.145 37.34C208.155 35.9859 206.971 34.7619 205.617 33.7073L206.359 30.2177L202.805 28.6813L199.251 27.1449L197.22 30.0745C195.527 29.8141 193.822 29.7881 192.156 30.0094L190.203 27.0146L186.597 28.4469L182.99 29.8792L183.628 33.3948C182.274 34.3844 181.051 35.5692 179.996 36.9234L176.507 36.1812L174.971 39.7358L173.435 43.2905L176.364 45.3217C176.104 47.0144 176.078 48.7201 176.299 50.3868L173.305 52.3399L174.737 55.9466L176.169 59.5533L179.684 58.9153C180.673 60.2695 181.858 61.4934 183.212 62.5481L182.47 66.0376L186.024 67.5741L189.578 69.1105L191.609 66.1808C193.301 66.4412 195.007 66.4543 196.673 66.2459L198.626 69.2407L202.232 67.8084L205.838 66.3761L205.2 62.8606C206.554 61.871 207.778 60.6861 208.832 59.332L212.321 60.0741L213.857 56.5195L215.394 52.9649L212.464 50.9336ZM189.044 60.621C182.157 57.6523 178.981 49.6576 181.949 42.7697C184.917 35.8817 192.911 32.7047 199.797 35.6734C206.684 38.6421 209.861 46.6368 206.892 53.5247C203.924 60.4127 195.931 63.5897 189.044 60.621Z",
    fill: "url(#paint32_linear_1046_17094)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.005 54.6315H110.289L112.463 50.2305H113.179L111.005 54.6315Z",
    fill: "#B8D6FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.605 54.2285H88.0273V54.7754H122.605V54.2285Z",
    fill: "#B8D6FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.501 56.0127H88.0273V59.1897H106.501V56.0127Z",
    fill: "#B8D6FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.91 48.4863H110.289V50.2311H119.91V48.4863Z",
    fill: "#B8D6FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.91 47.666H110.289V47.9915H119.91V47.666Z",
    fill: "#B8D6FF"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.44
  }, /*#__PURE__*/React.createElement("path", {
    d: "M294.261 69.3447H283.469V70.152H294.261V69.3447Z",
    fill: "#B8D6FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.261 70.5029H283.469V72.6904H294.261V70.5029Z",
    fill: "#B8D6FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.265 52.4307V59.7222H267.391V61.0113H285.265V62.1441H267.391V67.5346H285.265H285.669H286.072V52.4307H285.265Z",
    fill: "#B8D6FF"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M229.713 24.2154C229.83 23.4341 229.843 22.6529 229.739 21.8977L231.106 20.9993L230.455 19.3456L229.804 17.692L228.19 17.9785C227.734 17.3535 227.2 16.7936 226.575 16.3118L226.914 14.7103L225.287 14.0072L223.659 13.304L222.735 14.6452C221.954 14.528 221.173 14.515 220.418 14.6191L219.519 13.252L217.866 13.903L216.213 14.554L216.499 16.1686C215.874 16.6243 215.314 17.1582 214.833 17.7831L213.232 17.4446L212.529 19.0722L211.826 20.6998L213.166 21.6242C213.049 22.4055 213.036 23.1867 213.14 23.9419L211.773 24.8404L212.424 26.494L213.075 28.1476L214.69 27.8612C215.145 28.4861 215.679 29.046 216.304 29.5278L215.965 31.1293L217.593 31.8325L219.22 32.5356L220.144 31.1944C220.925 31.3116 221.707 31.3246 222.462 31.2205L223.36 32.5877L225.013 31.9366L226.667 31.2856L226.38 29.671C227.005 29.2153 227.565 28.6815 228.047 28.0565L229.648 28.395L230.351 26.7674L231.054 25.1398L229.713 24.2154ZM218.973 28.6554C215.809 27.2882 214.351 23.6294 215.718 20.4654C217.085 17.3014 220.743 15.8431 223.907 17.2102C227.07 18.5774 228.528 22.2362 227.161 25.4002C225.794 28.5643 222.136 30.0226 218.973 28.6554Z",
    fill: "url(#paint33_linear_1046_17094)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.58 16.443H158.138C157.448 16.443 156.875 15.8831 156.875 15.18V12.6409C156.875 11.9508 157.435 11.3779 158.138 11.3779H174.58C175.27 11.3779 175.843 11.9378 175.843 12.6409V15.18C175.83 15.8831 175.27 16.443 174.58 16.443Z",
    fill: "#D0E5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.58 25.9078H158.138C157.448 25.9078 156.875 25.3479 156.875 24.6448V22.1058C156.875 21.4157 157.435 20.8428 158.138 20.8428H174.58C175.27 20.8428 175.843 21.4027 175.843 22.1058V24.6448C175.83 25.3479 175.27 25.9078 174.58 25.9078Z",
    fill: "#D0E5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.58 35.3746H158.138C157.448 35.3746 156.875 34.8147 156.875 34.1116V31.5726C156.875 30.8825 157.435 30.3096 158.138 30.3096H174.58C175.27 30.3096 175.843 30.8695 175.843 31.5726V34.1116C175.83 34.8017 175.27 35.3746 174.58 35.3746Z",
    fill: "#D0E5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.717 0.112513C143.499 -11.6712 132.238 -18.9237 120.366 -18.5591C117.488 -18.468 114.585 -17.9472 111.721 -16.9185C103.077 -13.8196 96.8671 -6.93167 94.3285 1.20625C92.558 6.8442 92.558 13.0941 94.693 19.0836C94.9013 19.6826 95.1356 20.2685 95.383 20.8414C96.5156 23.4325 97.9867 25.7893 99.7442 27.8465C107.113 36.5053 119.337 40.1771 130.676 36.1147C145.322 30.8804 152.951 14.7608 147.717 0.112513ZM128.307 29.4741C119.806 32.521 110.641 29.7736 105.108 23.2763C103.793 21.7268 102.686 19.969 101.84 18.0159C101.658 17.5863 101.476 17.1436 101.319 16.7009C99.7182 12.2087 99.7182 7.52128 101.046 3.30258C102.96 -2.80412 107.607 -7.97333 114.091 -10.291C116.226 -11.0592 118.413 -11.4498 120.574 -11.5149C129.479 -11.7884 137.928 -6.35876 141.078 2.48228C145.01 13.4717 139.294 25.5549 128.307 29.4741Z",
    fill: "#D0E5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.837 18.0167L95.3798 20.8422C95.1325 20.2693 94.8981 19.6834 94.6898 19.0844C92.5418 13.0949 92.5548 6.84498 94.3253 1.20703L101.056 3.30336C99.728 7.53508 99.728 12.2095 101.329 16.7016C101.486 17.1574 101.655 17.587 101.837 18.0167Z",
    fill: "#98C3E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.7479 27.8469C97.9904 25.7766 96.5193 23.4329 95.3867 20.8418L101.844 18.0293C102.69 19.9824 103.797 21.7402 105.112 23.2896L99.7479 27.8469Z",
    fill: "#B5D2EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.547 76.0139L227.22 70.4931C226.7 70.0374 226.648 69.2561 227.103 68.7353C227.559 68.2145 228.34 68.1624 228.861 68.6181L233.339 72.5113L239.718 65.402C240.174 64.8942 240.968 64.8421 241.476 65.3109C241.983 65.7666 242.036 66.5609 241.567 67.0687L233.547 76.0139Z",
    fill: "url(#paint34_linear_1046_17094)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.414 53.7976C250.789 53.7976 250.281 53.2898 250.281 52.6648V37.04C250.281 36.415 250.789 35.9072 251.414 35.9072C252.039 35.9072 252.546 36.415 252.546 37.04V52.6648C252.546 53.3029 252.039 53.7976 251.414 53.7976Z",
    fill: "url(#paint35_linear_1046_17094)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.224 45.9853H243.601C242.976 45.9853 242.469 45.4775 242.469 44.8525C242.469 44.2275 242.976 43.7197 243.601 43.7197H259.224C259.848 43.7197 260.356 44.2275 260.356 44.8525C260.356 45.4775 259.848 45.9853 259.224 45.9853Z",
    fill: "url(#paint36_linear_1046_17094)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.863 179.837H100.144C97.2535 179.837 94.9102 177.494 94.9102 174.603V166.101C94.9102 163.21 97.2535 160.866 100.144 160.866H171.863V179.837Z",
    fill: "url(#paint37_linear_1046_17094)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.178 162.819V177.884H185.44V179.837H133.444C130.554 179.837 128.211 177.494 128.211 174.603V166.101C128.211 163.21 130.554 160.866 133.444 160.866H185.427V162.819H184.178Z",
    fill: "#FF9F55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.177 177.885H137.284C134.394 177.885 132.051 175.542 132.051 172.651V168.055C132.051 165.164 134.394 162.82 137.284 162.82H184.177V177.885Z",
    fill: "#EFF7FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.206 160.867H96.6915C93.0594 160.867 90.1172 157.924 90.1172 154.291V145.385C90.1172 141.752 93.0594 138.81 96.6915 138.81H175.206V160.867Z",
    fill: "url(#paint38_linear_1046_17094)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.136 141.088V158.601H190.217V160.867H147.516C143.884 160.867 140.941 157.924 140.941 154.291V145.385C140.941 141.752 143.884 138.81 147.516 138.81H190.217V141.075H189.136V141.088Z",
    fill: "#5284FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.138 158.601H150.824C147.192 158.601 144.25 155.658 144.25 152.025V147.663C144.25 144.031 147.192 141.088 150.824 141.088H189.138V158.601Z",
    fill: "#EFF7FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.641 138.81H178.318C182.249 138.81 185.439 135.62 185.439 131.687V118.888C185.439 114.956 182.249 111.766 178.318 111.766H118.641V138.81Z",
    fill: "url(#paint39_linear_1046_17094)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.949 114.552V136.023H106.855V138.81H149.4C153.332 138.81 156.521 135.62 156.521 131.687V118.888C156.521 114.956 153.332 111.766 149.4 111.766H106.855V114.552H107.949Z",
    fill: "#FF9F55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.953 136.024H145.577C149.482 136.024 152.646 132.86 152.646 128.954V121.623C152.646 117.717 149.482 114.553 145.577 114.553H107.953V136.024Z",
    fill: "#EFF7FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.33 111.766H100.06C95.933 111.766 92.5742 108.419 92.5742 104.279V92.2086C92.5742 88.081 95.92 84.7217 100.06 84.7217H163.33V111.766Z",
    fill: "url(#paint40_linear_1046_17094)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.661 87.5081V108.979H175.82V111.766H130.685C126.558 111.766 123.199 108.419 123.199 104.279V92.2086C123.199 88.081 126.545 84.7217 130.685 84.7217H175.807V87.5081H174.661Z",
    fill: "#5284FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.647 108.98H134.576C130.462 108.98 127.129 105.647 127.129 101.532V94.9566C127.129 90.8421 130.462 87.5088 134.576 87.5088H174.647V108.98Z",
    fill: "#EFF7FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.17 84.7214H115.062C112.497 84.7214 110.414 82.6381 110.414 80.073V68.9013C110.414 66.3362 112.497 64.2529 115.062 64.2529H181.17V84.7214Z",
    fill: "url(#paint41_linear_1046_17094)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.496 66.3623V82.6121H193.655V84.7214H145.694C143.13 84.7214 141.047 82.6381 141.047 80.073V68.9013C141.047 66.3362 143.13 64.2529 145.694 64.2529H193.655V66.3623H192.496Z",
    fill: "#5284FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.492 82.6124H149.218C146.653 82.6124 144.57 80.5291 144.57 77.9641V70.998C144.57 68.4329 146.653 66.3496 149.218 66.3496H192.505V82.6124H192.492Z",
    fill: "#EFF7FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.697 106.662L222.107 107.001C219.334 107.014 217.082 104.774 217.069 102.014L216.848 58.1735C216.835 55.4001 219.074 53.1475 221.834 53.1345L288.424 52.796C291.197 52.7829 293.449 55.0225 293.462 57.7829L293.683 101.623C293.696 104.397 291.47 106.649 288.697 106.662Z",
    fill: "#8DBDE3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.592 52.1372L245.91 52.2334L245.932 56.4521L264.613 56.3559L264.592 52.1372Z",
    fill: "#706865"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.579 63.5889C236.579 63.5889 236.606 75.8413 235.265 80.7501L232.388 82.573L222.207 82.6251C224.121 77.4689 224.095 63.654 224.095 63.654L236.579 63.5889Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.4 82.5729L232.387 80.724L235.277 80.7109L232.4 82.5729Z",
    fill: "#C9C9C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.902 60.5811C248.902 60.5811 248.915 69.0575 247.991 72.4429L246.012 73.7059L238.969 73.745C240.284 70.1773 240.271 60.6201 240.271 60.6201L248.902 60.5811Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.013 73.706L246 72.43L248.005 72.417L246.013 73.706Z",
    fill: "#C9C9C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.192 62.7432C266.192 62.7432 266.218 74.3446 264.955 79.006L262.221 80.7377L252.574 80.7898C254.384 75.8941 254.358 62.8213 254.358 62.8213L266.192 62.7432Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.22 80.7246L262.207 78.9798L264.941 78.9668L262.22 80.7246Z",
    fill: "#C9C9C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.489 77.5225C278.489 77.5225 278.502 85.3609 277.656 88.4989L275.807 89.6708L269.285 89.7098C270.509 86.4026 270.496 77.5745 270.496 77.5745L278.489 77.5225Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.809 89.6706V88.4857L277.657 88.4727L275.809 89.6706Z",
    fill: "#C9C9C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.489 61.4395C278.489 61.4395 278.502 69.2779 277.656 72.4159L275.807 73.5877L269.285 73.6268C270.509 70.3196 270.496 61.4915 270.496 61.4915L278.489 61.4395Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.809 73.5875V72.4027L277.657 72.3896L275.809 73.5875Z",
    fill: "#C9C9C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.622 69.1895C288.622 69.1895 288.635 75.205 287.985 77.6268L286.566 78.5253L281.566 78.5513C282.504 76.0123 282.491 69.2285 282.491 69.2285L288.622 69.1895Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.562 78.512V77.6006H287.982L286.562 78.512Z",
    fill: "#C9C9C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.462 79.0068C248.462 79.0068 248.475 85.2568 247.694 87.7567L246.028 88.6942L240.117 88.7203C241.224 86.0901 241.211 79.0459 241.211 79.0459L248.462 79.0068Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.023 88.6946V87.7441H247.69L246.023 88.6946Z",
    fill: "#C9C9C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.501 93.5244H222.691V94.4489H240.501V93.5244Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.235 99.9561H222.691V100.881H243.235V99.9561Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.345 96.7402H222.691V97.6647H235.345V96.7402Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.871 120.854H207.367V122.078H227.871V120.854Z",
    fill: "#FFAA55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.118 180.609H211.914V125.232H210.118V180.609Z",
    fill: "#706865"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.923 120.504H224.668V122.249H238.923V120.504Z",
    fill: "#CCBDB7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.496 105.672H229.094V122.065H234.496V105.672Z",
    fill: "#FFAA55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.991 122.093H200.008V125.244H278.991V122.093Z",
    fill: "#B59074"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.855 103.031C184.855 103.031 183.996 115.153 186.352 116.599C187.836 117.51 193.747 120.57 193.578 121.143C193.408 121.716 190.245 126.26 190.245 126.26C190.245 126.26 178.893 118.786 178.528 116.429C178.177 114.125 179.088 98.6951 180.65 97.979C181.822 97.4451 182.434 97.8878 183.905 98.9815C185.962 100.505 184.855 103.031 184.855 103.031Z",
    fill: "#D44040"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.567 106.492L206.57 106.127C206.57 106.127 205.32 103.198 204.773 103.263C204.148 103.341 203.367 103.549 203.367 103.549L205.567 106.492Z",
    fill: "#EAD8CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.779 107.005C205.649 106.913 203.657 103.072 203.657 103.072L199.387 103.658L201.691 108.202L205.779 107.005Z",
    fill: "#DA9B5B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.827 173.055C198.827 173.055 198.476 175.503 198.424 175.88C198.385 176.245 194.492 175.659 194.492 175.659L194.18 172.743C194.193 172.743 198.346 172.703 198.827 173.055Z",
    fill: "#424773"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.475 175.555C198.475 175.555 199.712 177.026 200.897 177.677C202.081 178.315 203.956 178.576 204.659 179.24C205.167 179.722 206.508 181.792 201.561 181.753C196.614 181.714 194.231 182.039 193.711 181.245C193.177 180.451 194.479 175.386 194.479 175.386C194.479 175.386 195.65 175.815 198.475 175.555Z",
    fill: "#292C47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.71 173.082C223.71 173.082 223.359 175.53 223.307 175.908C223.267 176.273 219.375 175.687 219.375 175.687L219.062 172.77C219.062 172.757 223.215 172.731 223.71 173.082Z",
    fill: "#424773"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.354 175.583C223.354 175.583 224.591 177.055 225.776 177.706C226.96 178.344 231.348 178.878 232.051 179.542C232.558 180.023 233.405 181.963 226.453 181.781C221.506 181.651 219.123 182.068 218.589 181.273C218.056 180.479 219.358 175.414 219.358 175.414C219.358 175.414 220.464 175.87 223.354 175.583Z",
    fill: "#292C47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.302 130.699C186.302 130.699 200.427 133.095 203.617 133.59C206.806 134.085 224.095 138.394 226.269 139.71C227.987 140.751 225.371 165.829 224.759 175.386H217.95L217.455 146.689C209.28 146.897 203.448 144.775 197.498 145.686C191.549 146.584 186.589 147.873 182.8 142.795C182.774 142.808 182.644 131.819 186.302 130.699Z",
    fill: "#292C47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.223 175.41L193.584 174.994L192.933 146.687C189.418 146.778 188.207 146.556 185.356 146.205L179.992 133.744C184.692 134.682 199.741 138.484 201.746 139.695C203.478 140.749 200.835 165.853 200.223 175.41Z",
    fill: "#292C47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.804 77.7721C192.804 77.7721 197.985 76.3399 199.951 80.3632C201.93 84.3866 201.031 92.0037 198.428 92.7199C195.824 93.436 192.062 92.6157 190.981 90.1157C189.9 87.6158 189.028 84.0611 189.289 81.7565C189.549 79.4518 191.437 78.319 192.804 77.7721Z",
    fill: "#EEA886"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.07 91.9118C197.07 91.9118 197.018 94.9717 197.357 95.6227C197.695 96.2737 190.145 96.1175 190.145 96.1175C190.145 96.1175 191.329 92.4456 190.665 89.3207C189.988 86.2087 197.07 91.9118 197.07 91.9118Z",
    fill: "#EEA886"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.255 88.1473C190.255 88.1473 190.659 88.9676 192.612 88.8374C194.565 88.7072 197.142 86.3504 197.975 86.1421C198.809 85.9338 198.848 85.465 198.848 85.465L199.29 86.2463L200.136 86.3765C200.136 86.3765 199.967 84.4234 200.813 83.1864C201.191 82.6395 200.241 75.6605 193.875 77.275C193.875 77.275 189.019 78.1604 188.954 80.8817C188.901 83.577 189.318 86.715 190.255 88.1473Z",
    fill: "#3A3F47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.742 95.5317C197.742 95.5317 197.716 94.2817 197.156 94.1645C196.597 94.0474 191.22 93.3052 190.53 93.5786L190.23 95.2192C190.243 95.2322 191.571 96.0525 197.742 95.5317Z",
    fill: "#E2D2CA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.291 84.8922C199.147 83.8766 197.989 82.7048 197.325 84.2933C196.661 85.8818 197.768 88.1995 198.523 88.0693C199.265 87.9521 199.499 86.2855 199.291 84.8922Z",
    fill: "#EEA886"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.229 110.241C220.255 110.254 220.268 110.268 220.229 110.241V110.241Z",
    fill: "#323657"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.282 78.4863C191.282 78.4863 184.968 78.1869 190.176 88.0435L191.282 78.4863Z",
    fill: "#3A3F47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.23 178.77L177.699 180.099L197.539 173.953L196.589 171.271L177.23 178.77Z",
    fill: "#918783"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.217 151.441H195.965V173.017H198.217V151.441Z",
    fill: "#918783"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.746 150.296H190.441V151.572H203.746V150.296Z",
    fill: "#5E5854"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.129 178.771L216.661 180.099L196.82 173.953L197.693 171.102L217.129 178.771Z",
    fill: "#918783"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.147 179.956V181.492L196.82 173.953L197.693 171.102L203.147 179.956Z",
    fill: "#918783"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.986 180.608C218.986 181.636 218.153 182.457 217.138 182.457C216.109 182.457 215.289 181.623 215.289 180.608C215.289 179.579 216.122 178.759 217.138 178.759C218.153 178.759 218.986 179.592 218.986 180.608Z",
    fill: "#BFB2AC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.307 180.608C203.307 181.636 202.473 182.457 201.458 182.457C200.43 182.457 199.609 181.623 199.609 180.608C199.609 179.579 200.443 178.759 201.458 178.759C202.473 178.759 203.307 179.592 203.307 180.608Z",
    fill: "#BFB2AC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.076 180.608C179.076 181.636 178.243 182.457 177.228 182.457C176.199 182.457 175.379 181.623 175.379 180.608C175.379 179.579 176.212 178.759 177.228 178.759C178.256 178.759 179.076 179.592 179.076 180.608Z",
    fill: "#BFB2AC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.561 150.295H183.808C182.493 150.295 181.426 149.227 181.426 147.912V147.847C181.426 146.532 182.493 145.464 183.808 145.464H210.561C211.876 145.464 212.944 146.532 212.944 147.847V147.912C212.931 149.227 211.876 150.295 210.561 150.295Z",
    fill: "#254380"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.894 125.243H267.098V180.62H268.894V125.243Z",
    fill: "#706865"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.733 113.576H210.865C209.551 113.576 208.496 112.508 208.496 111.206V83.0553C208.496 81.7402 209.564 80.6855 210.865 80.6855H252.733C254.048 80.6855 255.102 81.7532 255.102 83.0553V111.206C255.102 112.508 254.035 113.576 252.733 113.576Z",
    fill: "url(#paint42_linear_1046_17094)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.278 82.457H210.316V108.407H253.278V82.457Z",
    fill: "#F5F7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.443 122.131V121.545C241.443 121.545 240.623 117.899 234.804 117.899C228.985 117.899 229.102 122.131 229.102 122.131H241.443Z",
    fill: "#FFC655"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.029 118.446C229.029 118.446 230.292 118.342 230.76 118.069C231.229 117.795 233.989 115.92 234.64 116.22C235.291 116.519 239.626 117.847 239.47 118.472C239.313 119.11 238.923 119.045 238.61 118.928C238.311 118.811 235.16 118.16 234.887 118.264C234.887 118.264 237.973 119.397 237.986 120.217C237.999 121.037 237.335 121.246 237.048 121.545C236.762 121.858 236.397 122.626 235.603 122.691C234.809 122.756 230.916 121.402 230.122 121.337C229.328 121.272 227.844 121.389 227.74 121.259C227.636 121.129 229.029 118.446 229.029 118.446Z",
    fill: "#EEA886"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.037 97.2597C202.001 96.5566 197.77 95.528 197.77 95.528L190.259 95.2285C190.259 95.2285 183.372 96.7519 180.651 97.9759C180.391 98.0931 180.391 104.122 179.688 105.71L181.94 110.463C181.94 110.463 183.242 119.864 183.515 124.043C183.645 125.957 183.163 142.598 183.163 142.598C183.163 142.598 183.84 142.936 188.957 143.496C194.086 144.056 206.883 143.288 206.961 142.689C207.039 142.077 204.488 120.15 204.371 119.017C204.201 117.273 204.878 109.226 204.878 109.226C205.842 110.528 208.302 116.374 210.867 119.161C212.377 120.801 219.85 121.804 221.256 121.856C224.315 121.96 229.913 122.572 230.082 122.272C230.212 122.09 230.564 117.312 230.212 117.194C229.9 117.09 219.524 116.491 216.855 115.085C215.879 114.564 212.976 108.223 212.976 108.223C212.976 108.223 208.25 98.2623 206.037 97.2597Z",
    fill: "#D44040"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.222 142.104H178.62C176.095 142.104 174.051 140.06 174.051 137.534V116.558C174.051 114.032 176.095 111.987 178.62 111.987H191.222C193.748 111.987 195.792 114.032 195.792 116.558V137.534C195.792 140.06 193.748 142.104 191.222 142.104Z",
    fill: "#254380"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.94 149.084C188.737 149.084 186.134 148.003 184.22 145.881C179.872 141.089 180.653 132.652 180.692 132.3C180.757 131.636 181.356 131.155 182.02 131.22C182.684 131.285 183.165 131.871 183.1 132.548C183.087 132.639 182.397 140.282 186.016 144.28C187.474 145.894 189.414 146.675 191.94 146.675C192.604 146.675 193.15 147.222 193.15 147.886C193.15 148.55 192.604 149.084 191.94 149.084Z",
    fill: "#254380"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.597 85.8955H213.698C213.516 85.8955 213.359 85.7392 213.359 85.557V84.8669C213.359 84.6846 213.516 84.5283 213.698 84.5283H225.597C225.779 84.5283 225.935 84.6846 225.935 84.8669V85.557C225.935 85.7523 225.792 85.8955 225.597 85.8955Z",
    fill: "#DFE1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.597 88.8379H213.698C213.516 88.8379 213.359 88.6816 213.359 88.4993V87.8092C213.359 87.6269 213.516 87.4707 213.698 87.4707H225.597C225.779 87.4707 225.935 87.6269 225.935 87.8092V88.4993C225.935 88.6946 225.792 88.8379 225.597 88.8379Z",
    fill: "#DFE1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.799 106.349H214.501C213.876 106.349 213.355 105.842 213.355 105.204V91.9876C213.355 91.3626 213.863 90.8418 214.501 90.8418H224.799C225.424 90.8418 225.944 91.3496 225.944 91.9876V105.204C225.944 105.842 225.437 106.349 224.799 106.349Z",
    fill: "#DFE1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.101 106.351H230.302C229.299 106.351 228.492 105.544 228.492 104.541V86.3382C228.492 85.3356 229.299 84.5283 230.302 84.5283H249.101C250.103 84.5283 250.91 85.3356 250.91 86.3382V104.541C250.91 105.544 250.103 106.351 249.101 106.351Z",
    fill: "#DFE1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.309 104.58C266.497 104.58 264.219 102.301 264.219 99.4885C264.219 98.7333 264.388 98.0172 264.687 97.3662C265.495 95.6214 267.252 94.3975 269.309 94.3975C272.121 94.3975 274.399 96.6761 274.399 99.4885C274.399 100.452 274.126 101.35 273.67 102.119C272.759 103.603 271.145 104.58 269.309 104.58Z",
    fill: "#36572B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.14 104.124C262.174 104.124 260.586 102.536 260.586 100.57C260.586 100.452 260.586 100.348 260.599 100.231C260.768 98.4212 262.291 97.002 264.14 97.002C266.106 97.002 267.694 98.5905 267.694 100.557C267.694 101.807 267.056 102.9 266.08 103.538C265.533 103.916 264.856 104.124 264.14 104.124Z",
    fill: "#45613C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.39 99.7627C269.39 99.7627 269.676 102.119 269.767 105.336C269.858 108.552 267.307 108.552 267.307 108.552V120.322H265.536C265.536 120.322 265.575 108.317 264.69 107.354C263.805 106.39 263.805 101.807 263.805 101.807L264.312 101.507C264.312 101.507 263.557 106.924 266.994 107.718C270.431 108.513 269.129 99.9971 269.129 99.9971L269.39 99.7627Z",
    fill: "#925E2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.56 100.322C267.644 99.7747 265.717 98.5117 264.676 97.3789C265.483 95.6341 267.24 94.4102 269.297 94.4102C272.109 94.4102 274.388 96.6888 274.388 99.5012C274.388 100.465 274.114 101.363 273.659 102.131C273.515 101.441 272.76 100.725 270.56 100.322Z",
    fill: "#48753A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.097 101.546C261.913 101.208 261.118 100.739 260.598 100.231C260.767 98.4212 262.29 97.002 264.139 97.002C266.105 97.002 267.693 98.5905 267.693 100.557C267.693 101.807 267.055 102.9 266.078 103.538C265.727 102.861 264.907 102.067 263.097 101.546Z",
    fill: "#538742"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.094 114.854H273.058L272.446 117.067H261.836L261.094 114.854Z",
    fill: "#877670"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.594 117.066H271.472L270.236 122.092H263.453L262.594 117.066Z",
    fill: "#876455"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.814 97.458L263.501 97.5492C263.501 97.5492 263.02 96.2341 262.981 96.0518C262.968 95.8825 263.814 97.458 263.814 97.458Z",
    fill: "#538742"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.914 97.5479L262.437 98.0036C262.437 98.0036 262.424 98.1338 262.229 98.1338C262.034 98.1468 260.914 97.5479 260.914 97.5479Z",
    fill: "#538742"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.445 100.739H261.836C261.836 100.739 261.758 101.312 261.445 101.69C261.12 102.054 261.445 100.739 261.445 100.739Z",
    fill: "#538742"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.778 93.4601C270.935 93.5773 270.219 95.3221 270.219 95.3221H269.867C269.867 95.3091 270.622 93.3429 270.778 93.4601Z",
    fill: "#48753A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.125 94.8795C269.06 94.4108 269.424 93.6035 269.424 93.6035V94.8014C269.424 94.8144 269.19 95.3613 269.125 94.8795Z",
    fill: "#48753A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.937 101.755C271.716 101.573 271.703 99.9844 271.703 99.9844L272.055 100.115C272.055 100.115 272.159 101.937 271.937 101.755Z",
    fill: "#48753A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.535 117.066H271.472L270.235 122.092H268.295C269.402 118.056 265.535 117.066 265.535 117.066Z",
    fill: "#715346"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.922 122.091C269.44 121.883 268.646 119.591 268.268 118.394C268.138 117.977 268.047 117.69 268.047 117.69H272.499C272.109 120.438 271.184 122.091 271.184 122.091H269.922Z",
    fill: "#9E633A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.569 116.323C269.569 116.167 268.853 115.49 268.501 115.06C268.15 114.617 268.644 113.797 268.644 113.797C270.246 114.461 269.959 116.336 269.959 116.336C269.959 116.336 269.569 116.479 269.569 116.323Z",
    fill: "#97A43C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.482 116.389H270.287C270.287 116.389 270.143 113.146 271.328 112.704C272.513 112.261 272.513 111.389 272.513 111.389C272.513 111.389 272.864 112.6 272.292 113.238C271.719 113.876 271.055 114.618 271.159 115.217C271.276 115.816 270.482 116.389 270.482 116.389Z",
    fill: "#97A43C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.28 118.394C268.15 117.977 268.059 117.69 268.059 117.69H272.511C272.12 120.438 271.196 122.091 271.196 122.091H270.91C270.962 119.513 269.256 118.667 268.28 118.394Z",
    fill: "#82522F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.057 116.323H272.549L272.796 117.69H267.875L268.057 116.323Z",
    fill: "#C67B47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.028 82.5351C201.028 82.5351 199.739 86.4023 190.196 88.0429L189.246 86.7538C189.246 86.7538 197.682 85.8294 200.807 81.0117L201.028 82.5351Z",
    fill: "#254380"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.192 90.3994C183.255 90.9202 183.372 93.4332 183.372 93.4332H184.192H185.012C185.012 93.4463 185.129 90.9333 184.192 90.3994Z",
    fill: "#254380"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.335 83.2646H184.035V91.1422H184.335V83.2646Z",
    fill: "#254380"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.172 83.785L194.229 88.6548L205.985 78.069L192.485 74.6055L181.172 83.785Z",
    fill: "#1A2F59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.379 158.615H330.423C332.05 158.615 333.365 157.3 333.365 155.672V145.594C333.365 143.966 332.05 142.651 330.423 142.651H285.379V158.615Z",
    fill: "url(#paint43_linear_1046_17094)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.164 182.546H326.063C327.235 182.546 328.185 181.595 328.185 180.423V173.731C328.185 172.559 327.235 171.608 326.063 171.608H271.164V182.546Z",
    fill: "url(#paint44_linear_1046_17094)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.317 172.807V181.349H263.872V182.546H289.623C290.43 182.546 291.081 181.895 291.081 181.088V173.08C291.081 172.273 290.43 171.622 289.623 171.622H263.859V172.82H265.317V172.807Z",
    fill: "#F08533"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.316 181.348H288.372C289.153 181.348 289.778 180.723 289.778 179.942V174.213C289.778 173.432 289.153 172.807 288.372 172.807H265.316V181.348Z",
    fill: "#FAE6DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.699 144.291V156.973H276.918V158.614H309.555C311.235 158.614 312.602 157.247 312.602 155.567V145.685C312.602 144.005 311.235 142.638 309.555 142.638H276.918V144.278H277.699V144.291Z",
    fill: "#F08533"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.699 156.973H307.889C309.569 156.973 310.936 155.606 310.936 153.926V147.338C310.936 145.658 309.569 144.291 307.889 144.291H277.699V156.973Z",
    fill: "#FAE6DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.105 171.609H339.342C341.425 171.609 343.105 169.929 343.105 167.846V162.377C343.105 160.294 341.425 158.614 339.342 158.614H295.105V171.609Z",
    fill: "url(#paint45_linear_1046_17094)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.422 159.955V170.28H286.641V171.622H318.562C320.645 171.622 322.324 169.942 322.324 167.859V162.39C322.324 160.307 320.645 158.627 318.562 158.627H286.641V159.968H287.422V159.955Z",
    fill: "#495DA1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.422 170.28H316.987C319.07 170.28 320.749 168.601 320.749 166.518V163.718C320.749 161.635 319.07 159.955 316.987 159.955H287.422V170.28Z",
    fill: "#FAE6DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.638 163.567H305.305V163.242H292.638V163.567Z",
    fill: "#DECCC5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.716 164.562H311.242V164.236H297.716V164.562Z",
    fill: "#DECCC5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.356 175.338H281.023V175.012H268.356V175.338Z",
    fill: "#DECCC5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.435 176.331H286.961V176.006H273.435V176.331Z",
    fill: "#DECCC5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.718 177.243H288.316V176.918H282.718V177.243Z",
    fill: "#DECCC5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.505 153.188H306.031V152.862H292.505V153.188Z",
    fill: "#DECCC5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.383 154.101H296.98V153.775H291.383V154.101Z",
    fill: "#DECCC5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.595 142.651H296.864C295.953 142.651 295.211 141.909 295.211 140.997V138.302C295.211 137.391 295.953 136.648 296.864 136.648H319.595V142.651Z",
    fill: "url(#paint46_linear_1046_17094)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.505 137.26V142.039H323.908V142.664H307.427C306.515 142.664 305.773 141.921 305.773 141.01V138.315C305.773 137.403 306.515 136.661 307.427 136.661H323.908V137.286H323.505V137.26Z",
    fill: "#FF9F55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.501 142.026H308.634C307.723 142.026 306.98 141.284 306.98 140.373V138.914C306.98 138.003 307.723 137.261 308.634 137.261H323.501V142.026Z",
    fill: "#EFF7FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.65 136.635H295.759C294.613 136.635 293.676 135.697 293.676 134.551V131.726C293.676 130.58 294.613 129.643 295.759 129.643H320.65V136.635Z",
    fill: "url(#paint47_linear_1046_17094)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.077 130.372V135.919H325.415V136.635H311.876C310.73 136.635 309.793 135.697 309.793 134.551V131.726C309.793 130.58 310.73 129.643 311.876 129.643H325.415V130.359H325.077V130.372Z",
    fill: "#5284FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.077 135.919H312.931C311.785 135.919 310.848 134.981 310.848 133.836V132.455C310.848 131.31 311.785 130.372 312.931 130.372H325.077V135.919Z",
    fill: "#EFF7FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.727 129.643H321.642C322.892 129.643 323.895 128.627 323.895 127.39V123.328C323.895 122.078 322.879 121.075 321.642 121.075H302.727V129.643Z",
    fill: "url(#paint48_linear_1046_17094)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.34 121.961V128.771H298.988V129.656H312.475C313.725 129.656 314.728 128.641 314.728 127.404V123.341C314.728 122.091 313.712 121.089 312.475 121.089H298.988V121.974H299.34V121.961Z",
    fill: "#FF9F55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.34 128.759H311.265C312.502 128.759 313.504 127.756 313.504 126.519V124.201C313.504 122.965 312.502 121.962 311.265 121.962H299.34V128.759Z",
    fill: "#EFF7FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.888 121.075H296.826C295.512 121.075 294.457 120.008 294.457 118.706V114.878C294.457 113.562 295.525 112.508 296.826 112.508H316.888V121.075Z",
    fill: "url(#paint49_linear_1046_17094)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.48 113.38V120.19H320.845V121.075H306.537C305.222 121.075 304.168 120.008 304.168 118.706V114.878C304.168 113.562 305.235 112.508 306.537 112.508H320.845V113.393H320.48V113.38Z",
    fill: "#5284FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.48 120.19H307.774C306.472 120.19 305.418 119.136 305.418 117.834V115.75C305.418 114.448 306.472 113.394 307.774 113.394H320.48V120.19Z",
    fill: "#EFF7FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.548 112.495H301.588C300.781 112.495 300.117 111.831 300.117 111.024V107.482C300.117 106.675 300.781 106.011 301.588 106.011H322.548V112.495Z",
    fill: "url(#paint50_linear_1046_17094)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.133 106.688V111.845H326.497V112.509H311.291C310.484 112.509 309.82 111.845 309.82 111.037V107.496C309.82 106.688 310.484 106.024 311.291 106.024H326.497V106.688H326.133Z",
    fill: "#5284FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.13 111.832H312.409C311.601 111.832 310.938 111.168 310.938 110.36V108.16C310.938 107.353 311.601 106.688 312.409 106.688H326.13V111.832Z",
    fill: "#EFF7FE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1046_17094",
    x: 0,
    y: 0,
    width: 442,
    height: 197,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1046_17094"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1046_17094",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1046_17094",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(214.012 156.781) rotate(3.2764) scale(172.08 171.884)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1602,
    stopColor: "#90C2E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5806,
    stopColor: "#47AFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6783F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1046_17094",
    x1: -15.9994,
    y1: 90.0363,
    x2: 456.737,
    y2: 164.408,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9F55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD255"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1046_17094",
    x1: 324.251,
    y1: 74.9684,
    x2: 324.251,
    y2: 256.819,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCFCFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1046_17094",
    x1: 291.821,
    y1: 144.774,
    x2: 412.994,
    y2: 144.774,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBE6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1046_17094",
    x1: 307.046,
    y1: 136.351,
    x2: 307.046,
    y2: 89.3075,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDFDFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1046_17094",
    x1: 319.724,
    y1: 136.351,
    x2: 319.724,
    y2: 89.3077,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDFDFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1046_17094",
    x1: 340.222,
    y1: 82.6993,
    x2: 340.222,
    y2: 177.165,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDFDFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1046_17094",
    x1: 360.744,
    y1: 82.6992,
    x2: 360.744,
    y2: 177.166,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDFDFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1046_17094",
    x1: 381.391,
    y1: 82.6992,
    x2: 381.391,
    y2: 177.166,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDFDFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1046_17094",
    x1: 398.024,
    y1: 82.6993,
    x2: 398.024,
    y2: 177.166,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDFDFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1046_17094",
    x1: 386.534,
    y1: 82.6996,
    x2: 386.534,
    y2: 177.165,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDFDFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1046_17094",
    x1: 297.831,
    y1: 136.351,
    x2: 297.831,
    y2: 89.3077,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDFDFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1046_17094",
    x1: 306.86,
    y1: 197.344,
    x2: 306.86,
    y2: 2.40201,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEEEFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1046_17094",
    x1: 235.953,
    y1: 46.6301,
    x2: 235.953,
    y2: 143.472,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBE6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1046_17094",
    x1: 190.598,
    y1: 138.336,
    x2: 190.598,
    y2: 38.5779,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDFDFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_1046_17094",
    x1: 203.277,
    y1: 170.937,
    x2: 203.277,
    y2: 55.303,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDFDFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_1046_17094",
    x1: 223.775,
    y1: 170.937,
    x2: 223.775,
    y2: 55.303,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDFDFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_1046_17094",
    x1: 244.297,
    y1: 170.937,
    x2: 244.297,
    y2: 55.3027,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDFDFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_1046_17094",
    x1: 264.944,
    y1: 170.938,
    x2: 264.944,
    y2: 55.3036,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDFDFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_1046_17094",
    x1: 281.577,
    y1: 170.937,
    x2: 281.577,
    y2: 55.3033,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDFDFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_1046_17094",
    x1: 270.086,
    y1: 170.937,
    x2: 270.086,
    y2: 55.3024,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDFDFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_1046_17094",
    x1: 181.384,
    y1: 138.337,
    x2: 181.384,
    y2: 38.5782,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDFDFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_1046_17094",
    x1: 352.408,
    y1: 46.6301,
    x2: 352.408,
    y2: 143.472,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBE6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_1046_17094",
    x1: 307.046,
    y1: 170.937,
    x2: 307.046,
    y2: 55.3026,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDFDFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_1046_17094",
    x1: 319.724,
    y1: 170.937,
    x2: 319.724,
    y2: 55.303,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDFDFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_1046_17094",
    x1: 340.222,
    y1: 170.937,
    x2: 340.222,
    y2: 55.303,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDFDFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_1046_17094",
    x1: 360.744,
    y1: 170.937,
    x2: 360.744,
    y2: 55.3027,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDFDFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_1046_17094",
    x1: 381.391,
    y1: 170.938,
    x2: 381.391,
    y2: 55.3036,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDFDFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_1046_17094",
    x1: 398.024,
    y1: 170.937,
    x2: 398.024,
    y2: 55.3033,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDFDFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_1046_17094",
    x1: 386.534,
    y1: 170.937,
    x2: 386.534,
    y2: 55.3024,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDFDFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_1046_17094",
    x1: 297.831,
    y1: 170.937,
    x2: 297.831,
    y2: 55.3026,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDFDFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_1046_17094",
    x1: 331.114,
    y1: 169.972,
    x2: 331.114,
    y2: 82.4055,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBE6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_1046_17094",
    x1: 174.972,
    y1: 39.7681,
    x2: 213.865,
    y2: 56.5227,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9F55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD255"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_1046_17094",
    x1: 212.524,
    y1: 19.0938,
    x2: 230.354,
    y2: 26.7749,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9F55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD255"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_1046_17094",
    x1: 233.84,
    y1: 66.3694,
    x2: 236.645,
    y2: 75.0097,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9F55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD255"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_1046_17094",
    x1: 248.768,
    y1: 36.7132,
    x2: 254.056,
    y2: 53.0036,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9F55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD255"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_1046_17094",
    x1: 250.316,
    y1: 41.4891,
    x2: 252.504,
    y2: 48.2284,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9F55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD255"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_1046_17094",
    x1: 133.384,
    y1: 178.153,
    x2: 133.384,
    y2: 157.814,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9F55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD255"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_1046_17094",
    x1: 132.664,
    y1: 132.294,
    x2: 132.664,
    y2: 160.449,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#40D5E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5577FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_1046_17094",
    x1: 152.038,
    y1: 133.645,
    x2: 152.038,
    y2: 112.595,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9F55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD255"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_1046_17094",
    x1: 127.947,
    y1: 77.0491,
    x2: 127.947,
    y2: 100.697,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#40D5E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5577FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_1046_17094",
    x1: 145.798,
    y1: 65.3885,
    x2: 145.798,
    y2: 84.3032,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#40D5E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5577FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_1046_17094",
    x1: 255.101,
    y1: 97.1267,
    x2: 208.489,
    y2: 97.1267,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9F55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD255"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_1046_17094",
    x1: 296.368,
    y1: 150.633,
    x2: 328.116,
    y2: 150.633,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9F55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD255"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_1046_17094",
    x1: 281.455,
    y1: 177.076,
    x2: 312.896,
    y2: 177.076,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9F55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD255"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_1046_17094",
    x1: 351.224,
    y1: 165.115,
    x2: 291.256,
    y2: 165.115,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#609FF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3F9E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_1046_17094",
    x1: 307.398,
    y1: 142.116,
    x2: 307.398,
    y2: 135.669,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9F55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD255"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_1046_17094",
    x1: 307.171,
    y1: 127.579,
    x2: 307.171,
    y2: 136.503,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#40D5E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5577FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_1046_17094",
    x1: 313.315,
    y1: 128.007,
    x2: 313.315,
    y2: 121.335,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9F55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD255"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_1046_17094",
    x1: 305.677,
    y1: 110.068,
    x2: 305.677,
    y2: 117.564,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#40D5E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5577FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_1046_17094",
    x1: 311.331,
    y1: 106.372,
    x2: 311.331,
    y2: 112.368,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#40D5E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5577FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1046_17094"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 434,
    height: 189,
    fill: "white",
    transform: "translate(4 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlogThumbnail1);
export default __webpack_public_path__ + "static/media/blogThumbnail1.d942b46ec485e69a80a410ef3b42038a.svg";
export { ForwardRef as ReactComponent };